import axios from 'axios';
import { refreshAccessToken } from './userAuth';

const API = process.env.REACT_APP_API_PATH;

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    let status = null;

    if (error.response) {
      status = error.response.status;
    } else if (error.request) {
      // For network errors/connection refused, status is often available on the request object
      // but we should check if it exists before accessing.
      status = error.request.status || 0;
    }

    console.log('axios.interceptors.res status:', status);

    if (status === 401) {
      window.location.href = '/authentication/simple/login';
    }

    if (status === 403) {
      window.location.href = '/support-desk/table-view/1/0';
    }

    if (error.response && error.response.data && error.response.data.name === 'JsonWebTokenError') {
      window.location.href = '/authentication/simple/login';
    }

    if (error.response && error.response.data && error.response.data.name === 'TokenExpiredError') {
      console.log('axios.interceptors.res TokenExpiredError', error.response.data);
      // refreshAccessToken();
      window.location.href = '/authentication/simple/login';
    }

    return Promise.reject(error);
  },
);